(function () {
  var instances = new WeakMap();
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function setDigit(el, val) {
    if (!el) return;
    var next = String(val);
    if (el.textContent === next) return;
    el.textContent = next;
    if (prefersReducedMotion) return;
    el.removeAttribute('data-pulse');
    // Force reflow so the animation re-triggers on each value change.
    void el.offsetWidth;
    el.setAttribute('data-pulse', '');
  }

  function applyEnded(section, expiryMode) {
    if (expiryMode === 'hide') {
      section.hidden = true;
      return;
    }
    section.setAttribute('data-state', 'ended');
    var ended = section.querySelector('.chakrikka-sale-strip__ended');
    if (ended) ended.hidden = false;
  }

  function getVisibleStartUnit(minVisibleUnit, days, hours) {
    if (minVisibleUnit === 'days') return 'days';
    if (days > 0) return 'days';
    if (minVisibleUnit === 'hours') return 'hours';
    if (hours > 0) return 'hours';
    return 'mins';
  }

  function updateVisibleUnits(countdownEl, units, minVisibleUnit, days, hours) {
    if (!countdownEl) return;

    var order = ['days', 'hours', 'mins', 'secs'];
    var startUnit = getVisibleStartUnit(minVisibleUnit, days, hours);
    var startIndex = order.indexOf(startUnit);
    var visibleCount = 0;
    var firstVisible = null;

    order.forEach(function (name, index) {
      var unit = units[name];
      if (!unit) return;

      var isVisible = index >= startIndex;
      unit.hidden = !isVisible;
      unit.classList.remove('is-first-visible');

      if (isVisible) {
        visibleCount += 1;
        if (!firstVisible) firstVisible = unit;
      }
    });

    if (firstVisible) firstVisible.classList.add('is-first-visible');
    countdownEl.setAttribute('data-visible-units', String(visibleCount || 1));
  }

  function init(section) {
    if (!section || instances.has(section)) return;

    var endIso = section.getAttribute('data-end-iso');
    var expiryMode = section.getAttribute('data-expiry-mode') || 'show_message';
    var minVisibleUnit = section.getAttribute('data-min-visible-unit') || 'hours';
    var countdownEl = section.querySelector('[data-countdown]');

    if (!endIso) {
      if (countdownEl) countdownEl.style.display = 'none';
      return;
    }

    var endMs = Date.parse(endIso);
    if (isNaN(endMs)) {
      if (countdownEl) countdownEl.style.display = 'none';
      return;
    }

    var digitDays = section.querySelector('[data-unit="days"]');
    var digitHours = section.querySelector('[data-unit="hours"]');
    var digitMins = section.querySelector('[data-unit="mins"]');
    var digitSecs = section.querySelector('[data-unit="secs"]');
    var units = {
      days: digitDays && digitDays.closest('.chakrikka-sale-strip__unit'),
      hours: digitHours && digitHours.closest('.chakrikka-sale-strip__unit'),
      mins: digitMins && digitMins.closest('.chakrikka-sale-strip__unit'),
      secs: digitSecs && digitSecs.closest('.chakrikka-sale-strip__unit'),
    };

    var intervalId = null;

    function tick() {
      var diff = endMs - Date.now();
      if (diff <= 0) {
        setDigit(digitDays, 0);
        setDigit(digitHours, '00');
        setDigit(digitMins, '00');
        setDigit(digitSecs, '00');
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
        applyEnded(section, expiryMode);
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      updateVisibleUnits(countdownEl, units, minVisibleUnit, days, hours);
      setDigit(digitDays, days);
      setDigit(digitHours, pad(hours));
      setDigit(digitMins, pad(mins));
      setDigit(digitSecs, pad(secs));
    }

    tick();
    intervalId = setInterval(tick, 1000);

    instances.set(section, {
      destroy: function () {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
        instances.delete(section);
      },
    });
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-sale-strip]')) {
      init(scope);
    }
    if (scope.querySelectorAll) {
      var nodes = scope.querySelectorAll('[data-sale-strip]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }
  }

  function destroyIn(root) {
    if (!root) return;
    var candidates = [];
    if (root.matches && root.matches('[data-sale-strip]')) candidates.push(root);
    if (root.querySelectorAll) {
      var found = root.querySelectorAll('[data-sale-strip]');
      for (var i = 0; i < found.length; i++) candidates.push(found[i]);
    }
    candidates.forEach(function (section) {
      var inst = instances.get(section);
      if (inst) inst.destroy();
    });
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyIn(event.target);
  });
})();
